<div class="flex justify-between items-center pb-3 mb-3 border-b border-gray-200">
  <div>
    <h2 class="text-2xl font-semibold m-0">{{ title }}</h2>
    @if (subtitle) {
      <div class="text-color-secondary mt-1">{{ subtitle }}</div>
    }
  </div>
  <div class="flex gap-2">
    <ng-content></ng-content>
  </div>
</div>
